export default __webpack_public_path__ + "static/media/BOOFI.59648952.png";